import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import ForumGroupBasicInfoComponent, { TopicsBasicInfoComponent } from './topics-basic-info.component';

export const TopicsComponent = ({
    selectedTopics, handleInnerFormChange,changeCoverImage, back,changeLogoImage, handleFormSubmit, chapters,libraryData, onFormItemChange, id
}: any) => {
 
    const tabItems = [
        {
            id: 1,
            title: 'Chapters Basic Information',
            component: <TopicsBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectedTopics={selectedTopics}
                chapters={chapters}
                libraryData={libraryData}
                changeLogoImage={changeLogoImage}
                changeCoverImage={changeCoverImage}
            />,
            isVisible: true,
        },
        // {
        //     id: 2,
        //     title: 'Media',
        //     component:
        //         <UploadMedia
        //             handleInnerFormChange={handleInnerMediaFormChange}
        //             mediaFilesList={selectedTopics?.MediaMappings?.MediaFiles}
        //             ownerTypeId={1025}
        //             ownerId={id}
        //             folderName={'forumgroup'}
        //         />,
        //     isVisible: true,
        // },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}

export default TopicsComponent;
